import {isInStock} from "../../lookFunctions2";

/**
 * for total
 * @param wizardSelectedValues {wizardSelectedValueInterface[]}
 * @returns featuresThatShouldBeAddedToCartFromWizard {array}
 */
export const getSelectedWizardValuesFeaturesForCart = (wizardSelectedValues) => {
  return Object.keys(wizardSelectedValues).reduce((total, key) => {
    if (!wizardSelectedValues[key]) {
      return total
    }
    // if (!Number.isInteger(wizardSelectedValues[key].quantity) || wizardSelectedValues[key].quantity > 0 // why?
    if (wizardSelectedValues[key]?.quantityItems?.length) {
      wizardSelectedValues[key]?.quantityItems.forEach(quanItem => {
        if (isInStock(quanItem.quanFeature)) {
          total = [...total, quanItem]
        }
      })
    } else if (wizardSelectedValues[key].quantity >= 0 && wizardSelectedValues[key] && isInStock(wizardSelectedValues[key].selectedFeature)) {
      total = [...total, {quanFeature: wizardSelectedValues[key].selectedFeature, quantity: wizardSelectedValues[key].quantity}]
    }
    return total
  }, []).filter(item => item && item.quanFeature)
}
